import * as ActionType from '../constants/constant_action_types';

const DOWNLOADER_STATE = {
  data: null,
  download: false,
  encoding: '',
  format: null,
  isBlob: false,
  mimeType: '',
  name: null,
}

const downloaderReducer = function (state = DOWNLOADER_STATE, action) {
  switch (action.type) {
    case ActionType.SET_DOWNLOAD_DATA: {
      const {
        data,
        download,
        encoding,
        format,
        isBlob,
        mimeType,
        name,
      } = action.payload;

      return {
        ...state,
        data,
        download,
        encoding,
        format,
        isBlob,
        mimeType,
        name,
      };
    }

    case ActionType.IMMEDIATE_DOWNLOAD: {
      const {
        data,
        download,
        encoding,
        format,
        isBlob,
        mimeType,
        name,
      } = action.payload;

      return {
        ...state,
        data,
        download,
        encoding,
        format,
        isBlob,
        mimeType,
        name,
      }
    }

    case ActionType.INITIALIZE_DOWNLOADING_DATA: {
      return {
        download: true,
      };
    }

    case ActionType.DONE_DOWNLOADING_DATA: {
      return {
        download: false,
      };
    }

    default: return state;
  }

}

export default downloaderReducer;